export const theme = {
  primary: "#7733FF",
};
